import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FolioFactura } from "app/features/componentes/foliofactura";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

export interface Props {
    value: models.FiltroSaldosUsuariosZE;
    onChange: (value: models.FiltroSaldosUsuariosZE) => void;
    session: models.Session;
}

/**
* Componente para editar un FiltroGuia
*/
export class FiltroSaldosUsuariosZEComponent extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<models.FiltroSaldosUsuariosZE> {
        return {};
    }

    /**
     Establece la hora desde a la primer hora del día 12:00 am
     */
    private onFechaDesdeChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(0, 0, 0, 0);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroSaldosUsuariosZE> = { FechaDesde: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroSaldosUsuariosZE> = { FechaDesde: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    /**
    Establece la hora hasta a la ultima hora del día 11:59 pm
    */
    private onFechaHastaChange = (x: Date | null) => {
        if (x) {
            var fecha = new Date(x);
            fecha.setHours(23, 59, 59);
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroSaldosUsuariosZE> = { FechaHasta: fecha };
            this.props.onChange({ ...viejo, ...cambioFecha });
        } else {
            const viejo = this.props.value;
            const cambioFecha: Partial<models.FiltroSaldosUsuariosZE> = { FechaHasta: null };
            this.props.onChange({ ...viejo, ...cambioFecha });
        }
    }

    render() {
        const getField = this.getField;
        const Datetime = getField(kea.DateTime);
        const TipoOrigen = getField(selectores.OrigenMovimientoSaldoUsuarioZE);
        const UsuarioZE = getField(selectores.UsuarioZE);

        const EsProveedor = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE == null
        const EsChofer = this.props.session.IdUsuarioZE != null && this.props.session.IdChoferZE != null

        if (EsProveedor || EsProveedor ) {
            this.props.value.IdUsuarioZE = this.props.session.IdUsuarioZE
        }

        const validarProveedorId = this.props.value.IdUsuarioZE === undefined || this.props.value.IdUsuarioZE == null? null : this.props.value.IdUsuarioZE

        const { value } = this.props;
        return (
            <div>
                {kea.autogrid(2, [
                    <Datetime field="FechaDesde" label="Fecha desde (inicio):" onChange={this.onFechaDesdeChange} />,
                    <Datetime field="FechaHasta" label="Fecha hasta (final):" onChange={this.onFechaHastaChange} />,
                    <UsuarioZE field="IdUsuarioZE" label="Proveedor de zona extendida:" readonly={EsProveedor || EsChofer} />,
                    <TipoOrigen field="TipoOrigen" label="Tipo de origen:" />
                ])}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/actividadesusuariosze/list/filtro.tsx